import type { MessageKey } from "@wato/i18n";
import type { PaletteEntry } from "./ranking";

type Translate = (key: MessageKey) => string;

/** GAP-4: the jobs an owner opens the bar for — shown first, before any typing. */
const ACTIONS: readonly { id: string; label: MessageKey; to: string }[] = [
  { id: "channel-health", label: "command.action.channelHealth", to: "channels/health" },
  { id: "weekly-report", label: "command.action.weeklyReport", to: "reports/weekly" },
  { id: "connect-channel", label: "command.action.connectChannel", to: "channels" },
];

export function quickActions(workspaceId: string, t: Translate): PaletteEntry[] {
  return ACTIONS.map((a) => ({
    id: `action:${a.id}`,
    kind: "action" as const,
    label: t(a.label),
    to: `/w/${workspaceId}/${a.to}`,
  }));
}
